import { render, staticRenderFns } from "./counter-v2.vue?vue&type=template&id=1c05c010&"
import script from "./counter-v2.vue?vue&type=script&lang=ts&"
export * from "./counter-v2.vue?vue&type=script&lang=ts&"
import style0 from "./counter-v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports